import React from 'react';
import './Uputstvo.css';

const Uputstvo = () => {
  return (
    <div className="uputstvo-page">
      <div className="uputstvo-hero glass">
        <div className="uputstvo-hero-content">
          <h1 className="uputstvo-title">Uputstvo za korišćenje Geoportala</h1>
          <p className="uputstvo-subtitle">Agris Geoportal omogućava pregled i analizu poljoprivrednih i pedoloških slojeva, rad sa parcelama, merenje i preuzimanje podataka. Ovo uputstvo prikazuje glavne funkcionalnosti i način upotrebe.</p>
        </div>
      </div>

      <div className="uputstvo-content">
        <section className="uputstvo-section">
          <h2 className="section-title">Početak rada</h2>
          <div className="section-body">
            <ul className="bullets">
              <li><strong>Interfejs</strong>: Mapa sa kontrolama u uglovima i bočnim panelima zauzima ceo ekran.</li>
              <li><strong>Osnovne komande</strong>: Zumirajte točkićem, pomerajte mapu držanjem leve tipke miša, dvoklik za brzi zum.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section glass">
          <h2 className="section-title">Pretraga parcela</h2>
          <div className="section-body">
            <p>Polje za pretragu je u gornjem levom uglu. Unesite broj parcele i/ili naziv katastarske opštine. Sistem nudi rezultate u padajućoj listi.</p>
            <ul className="bullets">
              <li><strong>Odabir rezultata</strong>: Klikom na rezultat, mapa se centrirа na parcelu, a pretraga se čisti.</li>
              <li><strong>Brisanje unosa</strong>: Klik na ikonicu X briše tekst i zatvara rezultate.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section">
          <h2 className="section-title">Izbor slojeva (teme)</h2>
          <div className="section-body">
            <p>Lista tema otvara se preko desnog plutajućeg menija. Slojevi su grupisani (npr. Pedološka karta, Melioracija, Voćarstvo, Meteorologija, Vegetacioni period, KO parcele).</p>
            <ul className="bullets">
              <li><strong>Uključivanje slojeva</strong>: Označite željeni sloj. Redosled i vidljivost su usklađeni sa panelom.</li>
              <li><strong>Prozirnost (opacity)</strong>: Svaki sloj ima klizač za prozirnost radi lakšeg upoređivanja.</li>
              <li><strong>Legenda</strong>: Klik na naziv sloja otvara legendu za taj sloj.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section glass">
          <h2 className="section-title">Bazne karte i prikaz</h2>
          <div className="section-body">
            <p>Birajte baznu kartu (npr. satelit, karta) preko kontrola pri dnu. Geoportal podržava više načina prikaza:</p>
            <ul className="bullets">
              <li><strong>Jedna mapa</strong>: Standardni prikaz.</li>
              <li><strong>Dve mape</strong>: Upoređivanje A/B prikaza, svaki sa sopstvenim slojevima ili bazom.</li>
              <li><strong>Swipe</strong>: Klizač koji otkriva gornji sloj u odnosu na donji (vertikalni/horizontalni).</li>
              <li><strong>Lupa</strong>: Lokalno uvećanje i uporedni pregled izabranih slojeva na maloj površini.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section">
          <h2 className="section-title">Legenda</h2>
          <div className="section-body">
            <p>Legenda se otvara iz desnog menija. Prikazuje objašnjenja boja i vrednosti za aktivne slojeve (npr. pedološke klase, meteorološki rasteri, kulture).</p>
            <ul className="bullets">
              <li><strong>Više legendi</strong>: Moguće je prikazati više legendi istovremeno; redosled prati redosled tema.</li>
              <li><strong>Zatvaranje</strong>: U panelu legende svaka kartica ima dugme za uklanjanje.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section glass">
          <h2 className="section-title">Merenje</h2>
          <div className="section-body">
            <p>Alatke za merenje dostupne su u desnom meniju (Merenje). Podržani su: tačke (koordinate), dužina (linija), površina (poligon).</p>
            <ul className="bullets">
              <li><strong>Tačka</strong>: Klikom na mapu dodajete tačke i dobijate njihove koordinate. Možete ukloniti pojedinačne tačke ili sve.</li>
              <li><strong>Linija</strong>: Klikom dodajete temene tačke linije; dvoklik završava crtanje i izračunava dužinu.</li>
              <li><strong>Poligon</strong>: Klikom dodajete temena; dvoklik zatvara poligon i izračunava površinu.</li>
              <li><strong>Upravljanje</strong>: Svaka stavka u listi ima opciju uklanjanja. Dostupna su i dugmad za brisanje svih tačaka/linija/poligona.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section">
          <h2 className="section-title">Marker i informacije</h2>
          <div className="section-body">
            <p>Klik na mapu postavlja marker i otvara prozor sa informacijama o lokaciji i podacima iz aktivnih slojeva (GetFeatureInfo). Prozor se može zatvoriti dugmetom u gornjem desnom uglu.</p>
          </div>
        </section>

        <section className="uputstvo-section glass">
          <h2 className="section-title">Preuzimanje podataka</h2>
          <div className="section-body">
            <p>U sekciji Preuzimanje možete formirati listu parcela za izvoz.</p>
            <ul className="bullets">
              <li><strong>Pretraga za preuzimanje</strong>: Unesite broj parcele/KO; klikom na rezultat dodajete parcelu u listu.</li>
              <li><strong>Uklanjanje</strong>: Pored svake stavke nalazi se dugme za uklanjanje; dostupno je i brisanje kompletne liste.</li>
              <li><strong>Preuzimanje parcela</strong>: Kreira ZIP sa izabranim parcelama.</li>
              <li><strong>Preuzimanje izveštaja (PDF)</strong>: Generiše PDF izveštaj za selektovane parcele.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section">
          <h2 className="section-title">Saveti za rad</h2>
          <div className="section-body">
            <ul className="bullets">
              <li><strong>Red slojeva</strong>: Ako je potrebno, prilagodite redosled i prozirnost da biste jasnije videli preklapanja.</li>
              <li><strong>Upoređivanje</strong>: Za analize koristite dvostruki prikaz, swipe ili lupu umesto učitavanja previše slojeva odjednom.</li>
              <li><strong>Performanse</strong>: Ograničite broj uključenih rastera istovremeno radi bolje preglednosti i brzine.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section disclaimer glass">
          <h2 className="section-title">Napomena o izvorima podataka</h2>
          <div className="section-body">
            <ul className="bullets">
              <li><strong>Meteorološki podaci</strong>: Svi meteorološki podaci prikazani na Geoportalu dobijeni su na osnovu javno dostupnih podataka Republičkog hidrometeorološkog zavoda Srbije (RHMZ).</li>
              <li><strong>Katastarski podaci</strong>: Podaci o parcelama preuzeti su iz baze Republičkog geodetskog zavoda (RGZ). Podaci nisu u realnom vremenu i odgovaraju stanju iz juna 2025. godine, kada su poslednji put ažurirani.</li>
            </ul>
          </div>
        </section>

        <section className="uputstvo-section contact glass">
          <h2 className="section-title">Podrška</h2>
          <div className="section-body">
            <p>Za pitanja i sugestije kontaktirajte tim Agris Geoportala. Rado ćemo pomoći i unaprediti sistem u skladu sa potrebama korisnika.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Uputstvo;
